<template>
  <div class="body-info-cashier">
    <div class="title">收银台</div>

    <div class="cell-box">
      <div class="address-detail" v-if="addressInfo && addressInfo.tel && !qrUrl">
        <div class="top-addr">
          <div class="name">{{addressInfo.name}}</div>
          <div class="tel">{{addressInfo.tel}}</div>
        </div>
        <div class="bottom-addr">{{fullAddress}}</div>
      </div>
    </div>

    <div class="wx-pay-info" v-if="qrUrl">
      <div class="wx-pay-tip">请用微信扫描二维码完成支付</div>
      <img :src="qrUrl" class="qr-code"/>
      <div class="wx-sub-tip">先截屏
        <icon-svg icon-class="arrow-right"></icon-svg>
        打开微信扫一扫
        <icon-svg icon-class="arrow-right"></icon-svg>
        选择相册二维码
      </div>
    </div>

    <div class="cell-box">
      <RadioGroup v-model="selectedPayMethod" class="radio-container">
        <Radio
            v-for="(option, index) in payMethodOptions"
            :key="index"
            :name="option.value"
            checked-color="#fc9153"
            class="radio-item"
        >
          <img :src="option.src" class="pay-logo-img"/>
        </Radio>
      </RadioGroup>
    </div>

    <div class="confirm-pay-box">
      <div class="price-desc">¥<span style="font-size: 18px; color: red; font-weight: bold; margin-left: 5px;">{{(orderPrice / 100.0).toFixed(2)}}</span>
      </div>
      <Button @click="onClickConfirmPay" size="small" class="confirm-pay-btn" :loading="creditLoading" type="warning">
        确认支付
      </Button>
    </div>
  </div>
</template>

<script>
  import {Toast, Button, RadioGroup, Radio} from "vant"

  export default {
    name: "PayCardGoods",
    components: {RadioGroup, Toast, Button, Radio},
    props: {
      callbackUrl: {},
      orderPrice: {},
      orderId: {},
      orderType: {},
      addressInfo: {},
    },
    data() {
      return {
        creditLoading: false,
        selectedPayMethod: "alipay_v2",
        payMethodOptions: [
          {
            label: 'wx_qr_v2',
            value: 'wx_qr_v2',
            src: 'https://a1.wanwanshequ.com/static/public/wechat_pay.png'
          },
          {
            label: 'alipay_v2',
            value: 'alipay_v2',
            src: 'https://a1.wanwanshequ.com/static/public/ali_pay.png',
          },
        ],
        qrUrl: "",
      }
    },
    mounted() {
    },
    methods: {
      async onClickConfirmPay() {
        this.creditLoading = true
        if (this.selectedPayMethod === "wx_qr_v2") {
          this.onClickWxPay()
        } else {
          this.onClickAlipay()
        }
      },

      async onClickAlipay() {
        let payParams = {
          pay_method: this.selectedPayMethod,
          order_id: this.orderId,
          order_type: this.orderType,
          callback_url: this.callbackUrl,
        }
        this.creditLoading = true
        await this.$store.dispatch("PayOrder", payParams).then((data) => {
          if (data.code === 0) {
            let toUrl = data.data.redirect_to
            window.location.replace(toUrl)
          }
        }, () => {
          Toast("网络异常")
        })
        this.creditLoading = false
      },

      async onClickWxPay() {
        let payParams = {
          "pay_method": this.selectedPayMethod,
          "order_id": this.orderId,
          "order_type": this.orderType,
          "callback_url": this.callbackUrl,
        }
        this.creditLoading = true
        await this.$store.dispatch("PayOrder", payParams).then((data) => {
          if (data.code === 0) {
            let qrUrl = data.data.qr_url
            if (!qrUrl) {
              Toast("系统错误")
            } else {
              this.qrUrl = qrUrl
            }
          } else {
            Toast("系统错误")
          }
        }, () => {
          Toast("网路异常")
        })
        this.creditLoading = false
      },
    },
    computed: {
      fullAddress() {
        if (this.addressInfo) {
          return this.addressInfo.province + this.addressInfo.city + this.addressInfo.county + " " + this.addressInfo.addressDetail;
        }
        return ""
      },
    },

    watch: {
      selectedPayMethod(newVal, oldVal) {
        this.qrUrl = ""
      }
    }
  }
</script>

<style scoped lang="scss">

  .body-info-cashier {
    padding: 15px;

    .title {
      font-size: 18px;
      font-weight: bold;
      line-height: 1.5;
    }
  }

  .cell-box {
    background: white;
    color: #2d2d2d;
    margin-top: 12px;

    .address-detail {
      font-size: 12px;

      .top-addr {
        display: flex;
        align-items: center;
        line-height: 1.2;
        font-weight: bold;

        .tel {
          font-weight: bold;
          font-size: 14px;
          margin-left: 12px;
          color: #f66149;
        }
      }

      .bottom-addr {
        margin-top: 5px;
        line-height: 1.2;
      }
    }

    .radio-container {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .radio-item {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .pay-logo-img {
      height: 25px;
    }

    .tip-box {
      font-size: 12px;
      color: rgba(110, 110, 110, 0.75);
      padding: 5px 12px;
      line-height: 1.8;
    }
  }

  .info-gap {
    margin-top: 5px;
  }

  .confirm-pay-box {
    padding: 10px 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f2f2f2;

    .price-desc {
      padding: 0 12px;
      color: red;
    }

    .confirm-pay-btn {
      font-size: 16px;
      width: 65%;
    }
  }


  .wx-pay-info {
    padding: 12px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .wx-pay-tip {
      font-size: 18px;
    }

    .wx-sub-tip {
      color: #5d5d5d;
      font-size: 13px;
    }

    .qr-code {
      margin: 5px 0;
      width: 100px;
      height: 100px;
    }
  }

</style>
